<template>
  <v-card class="ma-3 pa-5">
    <h4>Create new Recommendation</h4>
    <v-row class="mx-2 mt-3">
      <v-select
          :items="typeOptions"
          class="mr-3"
          label="Type"
          v-model="newRec.type"
      />
      <v-text-field v-model="newRec.index" class="mr-3" type="text" label="Index"/>
      <v-text-field v-model="newRec.etText" class="mr-3" type="text" label="Text ET"/>
      <v-text-field v-model="newRec.etInfoLabel" class="mr-3" type="text" label="Info Label ET"/>
      <v-btn class="mt-4" @click="createNewRecommendation" small color="primary">Save</v-btn>
    </v-row>
  </v-card>
</template>
<script>

import {mapActions, mapState} from "vuex";

export default {
  name: "CreateRecommendationCard",
  data() {
    return {
      typeOptions: ['suggestion', 'info', 'warning']
    }
  },
  computed: {
    ...mapState('rec', ['newRec'])
  },
  methods: {
    ...mapActions('rec', ['handleNewRecClick', 'fetchRecTableData']),
    async createNewRecommendation() {
      if (!this.newRec.index) {
        return alert('Please fill Index field!')
      }
      if (!this.newRec.type) {
        return alert('Please select a type')
      }
      await this.handleNewRecClick()
    }
  },
  watch: {
    newRec: function () {
      if (Object.keys(this.newRec).length === 0)
        this.fetchRecTableData()
    }
  }
}
</script>

<style scoped>

</style>